import { useState } from 'react';
import Button from '../../../components/base/Button';
import BookingCalendar from '../../../components/feature/BookingCalendar';

export default function ContactSection() {
  const [isBookingOpen, setIsBookingOpen] = useState(false);
  const [formData, setFormData] = useState({
    nome: '',
    email: '',
    telefono: '',
    tipo_servizio: '',
    messaggio: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const openBookingCalendar = () => {
    setIsBookingOpen(true);
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (isSubmitting) return;
    setIsSubmitting(true);
    
    try {
      const subject = `Nuova richiesta contatto`;
      const plain = `Richiesta di contatto\n\n` +
        `Nome: ${formData.nome}\n` +
        `Email: ${formData.email}\n` +
        `Telefono: ${formData.telefono}\n` +
        `Messaggio: ${formData.messaggio}`;
      const html = `<!DOCTYPE html><html><head><meta charset=\"UTF-8\"><meta name=\"viewport\" content=\"width=device-width,initial-scale=1\"><title>Richiesta di Contatto</title></head><body style=\"margin:0;padding:0;background:#f6f8fb;font-family:Arial,Helvetica,sans-serif;color:#1f2937;\">\n          <table role=\"presentation\" width=\"100%\" cellspacing=\"0\" cellpadding=\"0\" style=\"background:#f6f8fb;padding:24px 0;\">\n            <tr><td align=\"center\">\n              <table role=\"presentation\" width=\"600\" cellspacing=\"0\" cellpadding=\"0\" style=\"max-width:600px;width:100%;background:#ffffff;border-radius:12px;box-shadow:0 6px 24px rgba(31,41,55,0.08);overflow:hidden;\">\n                <tr>\n                  <td style=\"background:#1e3a8a;padding:20px 24px;color:#ffffff;font-weight:bold;font-size:18px;\">\n                    AffittoOnline.it • Richiesta di Contatto\n                  </td>\n                </tr>\n                <tr>\n                  <td style=\"padding:24px 24px 8px 24px;\">\n                    <div style=\"font-size:16px;font-weight:600;margin-bottom:8px;color:#111827;\">Dettagli</div>\n                    <table role=\"presentation\" width=\"100%\" cellspacing=\"0\" cellpadding=\"0\" style=\"border-collapse:collapse;\">\n                      <tr><td style=\"padding:8px 0;color:#6b7280;width:160px;\">Nome</td><td style=\"padding:8px 0;color:#111827;\">${formData.nome}</td></tr>\n                      <tr><td style=\"padding:8px 0;color:#6b7280;width:160px;\">Email</td><td style=\"padding:8px 0;color:#111827;\">${formData.email}</td></tr>\n                      ${formData.telefono ? `<tr><td style=\"padding:8px 0;color:#6b7280;width:160px;\">Telefono</td><td style=\"padding:8px 0;color:#111827;\">${formData.telefono}</td></tr>` : ''}\n                      ${formData.tipo_servizio ? `<tr><td style=\"padding:8px 0;color:#6b7280;width:160px;\">Servizio</td><td style=\"padding:8px 0;color:#111827;\">${formData.tipo_servizio}</td></tr>` : ''}\n                    </table>\n                    ${formData.messaggio ? `<div style=\"margin-top:12px;padding:12px;border:1px solid #e5e7eb;border-radius:8px;\"><div style=\"color:#6b7280;font-size:12px;margin-bottom:6px;\">Messaggio</div><div style=\"color:#111827;line-height:1.5;\">${formData.messaggio.replace(/</g,'&lt;').replace(/>/g,'&gt;')}</div></div>` : ''}\n                  </td>\n                </tr>\n                <tr><td style=\"padding:24px;color:#6b7280;font-size:12px;\">AffittoOnline.it — Contratti di Locazione in Videoconferenza</td></tr>\n              </table>\n            </td></tr>\n          </table>\n        </body></html>`;

      if (__MAIL_WEBHOOK_URL__) {
        const res = await fetch(__MAIL_WEBHOOK_URL__, {
          method: 'POST',
          headers: { 'content-type': 'application/json' },
          body: JSON.stringify({
            to: __CONTACT_EMAIL__,
            subject,
            text: plain,
            html,
            reply_to_email: formData.email,
            reply_to_name: formData.nome,
          }),
        });
        if (res.ok) {
          setSubmitStatus('success');
          setFormData({ nome: '', email: '', telefono: '', tipo_servizio: '', messaggio: '' });
        } else {
          setSubmitStatus('error');
        }
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <section id="contatti" className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              Hai domande o dubbi? siamo qui per aiutarti.
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Contattaci al numero <a href="tel:+393470088959" className="text-blue-600 font-bold">+39 3470088959</a> o inviaci un messaggio
              </p>
          </div>

          <div className="max-w-2xl mx-auto">
            <form onSubmit={handleSubmit} className="bg-gray-50 rounded-xl p-8" data-readdy-form id="contatto-form">
          

              {submitStatus === 'success' && (
                <div className="mb-6 p-4 bg-green-100 border border-green-400 text-green-700 rounded-lg">
                  <i className="ri-check-circle-fill mr-2"></i>
                  Messaggio inviato con successo! Ti contatteremo presto.
                </div>
              )}

              {submitStatus === 'error' && (
                <div className="mb-6 p-4 bg-red-100 border border-red-400 text-red-700 rounded-lg">
                  <i className="ri-error-warning-fill mr-2"></i>
                  Errore nell'invio del messaggio. Riprova più tardi.
                </div>
              )}

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
                <div>
                  <label htmlFor="nome" className="block text-sm font-medium text-gray-700 mb-2">
                    Nome Completo *
                  </label>
                  <input
                    type="text"
                    id="nome"
                    name="nome"
                    value={formData.nome}
                    onChange={handleInputChange}
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                    placeholder="Il tuo nome completo"
                  />
                </div>

                <div>
                  <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2">
                    Email *
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                    placeholder="la-tua-email@esempio.it"
                  />
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
                <div>
                  <label htmlFor="telefono" className="block text-sm font-medium text-gray-700 mb-2">
                    Telefono
                  </label>
                  <input
                    type="tel"
                    id="telefono"
                    name="telefono"
                    value={formData.telefono}
                    onChange={handleInputChange}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                    placeholder="+39 123 456 7890"
                  />
                </div>

                
              </div>

              <div className="mb-6">
                <label htmlFor="messaggio" className="block text-sm font-medium text-gray-700 mb-2">
                  Messaggio
                </label>
                <textarea
                  id="messaggio"
                  name="messaggio"
                  value={formData.messaggio}
                  onChange={handleInputChange}
                  rows={4}
                  maxLength={500}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm resize-none"
                  placeholder="Descrivi brevemente le tue esigenze o fai le tue domande..."
                ></textarea>
                <div className="text-right text-xs text-gray-500 mt-1">
                  {formData.messaggio.length}/500 caratteri
                </div>
              </div>

              <Button 
                type="submit" 
                size="lg" 
                className="w-full"
                disabled={isSubmitting}
              >
                {isSubmitting ? (
                  <>
                    <i className="ri-loader-4-line mr-2 animate-spin"></i>
                    Invio in corso...
                  </>
                ) : (
                  <>
                    <i className="ri-send-plane-fill mr-2"></i>
                    Invia Messaggio
                  </>
                )}
              </Button>
            </form>
          </div>
        </div>
      </section>

      <BookingCalendar 
        isOpen={isBookingOpen} 
        onClose={() => setIsBookingOpen(false)} 
      />
    </>
  );
}